import {createRouter, createWebHistory} from 'vue-router'
import Products from "@/views/Products.vue";
import HomeView from "@/views/HomeView.vue";
import Blogs from "@/views/Blogs.vue";
import Projects from "@/views/Projects.vue";
import Contact from "@/views/Contact.vue";
import About from "@/views/About.vue";
import ProductDetail from "@/views/ProductDetail.vue";
import ProjectDetail from "@/views/ProjectDetail.vue";
import BlogsDetail from "@/views/BlogsDetail.vue";
import NotFound from "@/views/NotFound.vue";
import Privacy from "@/views/Privacy.vue";
import Videos from "@/views/Videos.vue";
import VideoDetail from "@/views/VideoDetail.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/about',
        name: 'about',
        component: About
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '/products',
        name: 'Products',
        component: Products
    },
    {
        path: '/blogs',
        name: 'Blogs',
        component: Blogs
    },
    {
        path: '/projects',
        name: 'Projects',
        component: Projects
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/videos',
        name: 'Videos',
        component: Videos
    },
    {
        path: '/videos/:str',
        name: 'VideoDetail',
        component: VideoDetail
    },
    {
        path: '/3d-models',
        name: 'SteelModels',
        component: () => import(/* webpackChunkName: "steel-models" */ '@/views/SteelModels.vue')
    },
    {
        path: '/3d-models/:str',
        name: 'SteelModelDetail',
        component: () => import(/* webpackChunkName: "steel-models" */ '@/views/SteelModelDetail.vue')
    },
    {
        path: '/products/:str',
        name: 'ProductDetail',
        component: ProductDetail,
    },
    {
        path: '/projects/:str',
        name: 'ProjectDetail',
        component: ProjectDetail,
    },
    {
        path: '/blogs/:str',
        name: 'BlogDetail',
        component: BlogsDetail
    },
    {
        path: '/privacy_policy',
        name: 'Privacy',
        component: Privacy
    },
    {
        path: '/:pathMatch(.*)*', // 使用通配符匹配任何路径
        name: 'NotFound',
        component: NotFound
    },

]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

export default router
